jQuery(document).ready(function($) {

	$(document).on('click', '.js-header-navbar a', function(){

		if ( $(this).attr('href') === "#" ) {
			return false;       // stop the function
		}

		$('#navbarNavDropdown').removeClass('show');
	});

	$(document).mouseup(function (e) {
		var container = $(".js-header-navbar");

		if ( e.target !== container [0] && container.has(e.target).length === 0 ){
			$('#navbarNavDropdown').removeClass('show');
		}
	});


	$(window).scroll(function(){
		var offset     = document.documentElement.scrollTop;
		var	mainNavObj = $(".js-header-navbar");
	
		if ((offset > 115) || $('body').scrollTop() > 115) { 
			mainNavObj.addClass('is-sticky');
		} else {
			mainNavObj.removeClass('is-sticky');
		}
	});
});